<form (submit)="onSubmit($event)" class="confirm-dialog">
  <h2 mat-dialog-title>Confirm</h2>
  <mat-dialog-content>
    {{ data.message }}
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button class="bordered-button btn-cancel" type="button"
            (click)="dialogRef.close(false)">{{ data.cancelText }}</button>
    <button mat-button class="bordered-button" type="submit">{{ data.okText }}</button>
  </mat-dialog-actions>
</form>
